module.exports = __webpack_public_path__ + "static/media/Penguin Boy.82250569.jpg";